module.exports = __webpack_public_path__ + "front/img/zzs01.9911b3b4.png";